var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.rightW ? _vm.rightW : 'calc(100% - 230px)' }),attrs:{"id":"rightMainContainer"}},[_c('operations',{ref:"operations",on:{"callback":_vm.refreshTable}}),_c('navAndSearch'),_c('fileTable',{ref:"fileTable"}),_c('compress')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }